export default __webpack_public_path__ + "static/media/ouro.d52204e6.png";